// extracted by mini-css-extract-plugin
export var actionButton = "_8m-1";
export var actionButtons = "_8m-2";
export var actions = "_8m-0";
export var aiUnread = "_8m-10";
export var alignCenter = "_8m-h";
export var backWrapper = "_8m-3";
export var cellContainer = "_8m-4";
export var checkboxContainer = "_8m-5";
export var contentContainer = "_8m-6";
export var contentHeader = "_8m-8";
export var conversationsTableWrapper = "_8m-s";
export var draftReplyBadgeContainer = "_8m-m";
export var dropdownItem = "_8m-b";
export var dropdownItemsContainer = "_8m-a";
export var dropdownTitle = "_8m-c";
export var errorIcon = "_8m-7";
export var filter = "_8m-d";
export var gray = "_8m-i";
export var headerActionButtons = "_8m-e";
export var headerCheckboxContainer = "_8m-f";
export var icon = "_8m-j";
export var menuContainer = "_8m-k";
export var noMoreTicketsIcon = "_8m-12";
export var noMoreTicketsSubText = "_8m-13";
export var oneLine = "_8m-l";
export var optionsButton = "_8m-n";
export var plus = "_8m-o";
export var portalButtonsWrapper = "_8m-g";
export var red = "_8m-p";
export var scrolledTop = "_8m-9";
export var search = "_8m-q";
export var selectedConversationsCount = "_8m-r";
export var spinner = "_8m-t";
export var strong = "_8m-u";
export var summaryCell = "_8m-v";
export var tableContainer = "_8m-11";
export var tagContainer = "_8m-w";
export var threeDots = "_8m-x";
export var twoLines = "_8m-y";
export var unread = "_8m-z";